export class ShowArchivedButton {
        text = 'No';
        enabled = false;
    }
